let config = [{
        key: "tips",
        value: "命名规则：只能以字母开头，可以包含字母、数字、下划线",
        type: "tips"
    },
    {
        name: "锚点",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
            key: "anchor_name",
            name: "锚点ID",
            type: "text"
        }]
    }
];

export default config;